/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
// import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";

function Footer({ company }) {
  const { href, name } = company;
  const { size } = typography;

  return (
    <SuiBox
      width="100%"
      justifyContent="space-between"
      alignItems="left"
      px={1.5}
      textAlign="left"
      style={{bottom: "0" ,position: "relative", paddingBottom: "20px"  }}
    >
      <SuiBox
        justifyContent="center"
        alignItems="center"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
      
                  </SuiBox>
    </SuiBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "https://internetmy.org", name: "Digital Internet Association" },
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
};

export default Footer;
